//function common header crm links
const eventDetailsHeaderLinks = (
  id,
  t,
  slug = "",
  isEventModerator = false
) => {
  const basePath = `/admin/events`;

  // Helper function to create link objects
  const createLink = (title, path) => ({
    title: typeof title === "string" ? title : t(title),
    link: `${basePath}/${path}/${id}`,
  });

  // Common links that appear in both cases
  const commonLinks = [
    createLink(t("Event Info"), "info"),
    createLink(t("Sub Events"), "subevents"),
    createLink(t("Members"), "members"),
  ];

  // Links that always appear at the end
  const endingLinks = [createLink(t("Gallery"), "gallery")];

  if (isEventModerator) {
    endingLinks.push(createLink("Feedback 360", "feedbackrules"));
  }

  if (slug === "buysell") {
    return [
      ...commonLinks,
      createLink(t("Products"), "products"),
      createLink(t("Buy Quotations"), "quotations/buy"),
      createLink(t("Sell Quotations"), "quotations/sell"),
      ...endingLinks,
    ];
  }

  return [
    ...commonLinks,
    createLink(t("Partners"), "eventpartner"),
    // createLink(t("Agenda"), "agenda"),
    ...endingLinks,
  ];
};

// A factory function to generate the menu configuration.
// This keeps the config clean and allows passing dependencies like `t`.
const getMenuItemsConfig = (t, isEventModerator) => {
  const baseMenu = [
    {
      key: "edit",
      label: t("View Details"),
      path: "info",
      // Condition is a function that returns true if the item should be shown.
      // No condition means it's always shown.
    },
    {
      key: "subevents",
      label: t("View Sub Events"),
      path: "subevents",
    },
    {
      key: "member",
      label: t("View Members"),
      path: "members",
    },
    {
      key: "partner",
      label: t("View Partners"),
      path: "eventpartner",
      condition: (slug) => slug !== "buysell",
    },
    // {
    //   key: "agenda",
    //   label: t("View Agenda"),
    //   path: "agenda",
    //   condition: (slug) => slug !== "buysell",
    // },
    {
      key: "products",
      label: t("Products"),
      path: "products",
      condition: (slug) => slug === "buysell",
    },
    {
      key: "buy",
      label: t("Buy Quotations"),
      path: "quotations/buy",
      condition: (slug) => slug === "buysell",
    },
    {
      key: "sell",
      label: t("Sell Quotations"),
      path: "quotations/sell",
      condition: (slug) => slug === "buysell",
    },
    {
      key: "gallery",
      label: t("View Gallery"),
      path: "gallery",
    },
  ];

  if (isEventModerator) {
    baseMenu.push({
      key: "feedback",
      label: "Feedback 360", // Hardcoded text, no t() function
      path: "feedbackrules",
    });
  }

  return baseMenu;
};

//get duration
const getDuration = (startTimeStr, endTimeStr) => {
  // Convert start time and end time to Date objects
  const startTime = new Date(`2000-01-01T${startTimeStr}:00`);
  const endTime = new Date(`2000-01-01T${endTimeStr}:00`);

  // Calculate the duration in milliseconds
  const durationMs = endTime - startTime;

  // Convert the duration to hours and minutes
  const hours = Math.floor(durationMs / (1000 * 60 * 60));
  const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));

  // Format the duration as "hh:mm"
  const durationStr = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;

  return durationStr;
};

export { eventDetailsHeaderLinks, getDuration, getMenuItemsConfig };
